import { IsBoolean, IsNumber, IsString } from 'class-validator';

export class RegionDto {
  @IsNumber()
  id: number;

  @IsString()
  code: string;

  @IsString()
  name: string;

  @IsBoolean()
  current: boolean;
}
